import { useCurrentAddressInfo } from './address';

import { getCurrentAddress } from '@/utils';

export enum UserType {
  pro = 'Pro',
  common = 'Common',
  visit = 'Visit',
}

export const useUserType = () => {
  const { address } = useCurrentAddressInfo();
  return address ? UserType.common : UserType.visit;
};

export const getGaUserType = () => {
  const isLogin = !!getCurrentAddress();
  return isLogin ? UserType.common : UserType.visit;
};
